<template>
  <span @click="action" style="cursor: pointer;" :class="`o-link-arrow ob1-link-large${back ? ' back' : ''}${!maxWidth ? ' no-max-width' : ''}${customClass ? ` ${customClass}` : ''}`" aria-disabled="true" tabindex="-1">
    {{ text }}
  </span>
</template>

<script>
export default {
  name: 'AlertInput',
  props: {
    action: {
      type: Function,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    back: {
      type: Boolean,
      required: false,
    },
    customClass: {
      type: String,
      required: false,
      default: null,
    },
    maxWidth: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.o-link-arrow {
  &.no-max-width {
    max-width: unset;
  }
}
</style>